import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  // if(window){
  //   window.console.log=function(){};
  // }
}

// Microsoft Clarity web tag. Loaded here instead of index.html so each build
// records into its own Clarity project (environment.clarityProjectId).
// window.clarity is defined as a queue immediately, so ClarityService calls made
// before the tag finishes loading are replayed once it does.
function loadClarity(projectId: string) {
  if (!projectId) {
    return;
  }
  (function (c: any, l: Document, a: string, r: string, i: string) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    const t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = 'https://www.clarity.ms/tag/' + i;
    const y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', projectId);
}
loadClarity(environment.clarityProjectId);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
